/* eslint-disable no-plusplus */
import Vue from 'vue';
// eslint-disable-next-line import/extensions
import 'reset-css';
import 'animate.css';
import 'vue-slider-component/theme/default.css';
// feather icons
import './assets/fonts/style.css';
// import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// pretty-checkboxes
import 'pretty-checkbox/dist/pretty-checkbox.css';
import VTooltip from 'v-tooltip';
import VueTelInput from 'vue-tel-input';
import { VueMasonryPlugin } from 'vue-masonry';
import vueDebounce from 'vue-debounce';
import Vuelidate from 'vuelidate';
import PrettyCheckbox from 'pretty-checkbox-vue';
import IdleVue from 'idle-vue';
import VueMeta from 'vue-meta';

// #region fontAwesome icons

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { library } from '@fortawesome/fontawesome-svg-core';

import { faLock, faArrowRight, faArrowLeft, faClipboardListCheck, faInfoCircle, faCheck, faSearch, faPlayCircle, faTimesCircle, faChevronRight, faPlus, faMinus, faTimes, faFilePdf, faUsers, faPencil, faPiggyBank, faCoins, faSave, faEdit, faLayerGroup } from '@fortawesome/pro-light-svg-icons';
import {
    faTimesCircle as fadTimesCircle,
    faUsers as fadUsers,
    faPencil as fadPencil,
    faInfoCircle as fadInfoCircle,
    faCalendarDay,
} from '@fortawesome/pro-duotone-svg-icons';


// #endregion

import VueAwesomeSwiper from 'vue-awesome-swiper';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/css/swiper.min.css';

import App from './App.vue';
import router from './router';
import './services/interceptor';
import store from './store';


library.add(faLock, faArrowRight, faArrowLeft, faClipboardListCheck, faInfoCircle, faCheck, faSearch, faPlayCircle, faTimesCircle, faChevronRight, faPlus, faMinus, faTimes, faFilePdf, faUsers, faPencil, fadTimesCircle, fadUsers, fadPencil, fadInfoCircle, faPiggyBank, faCoins, faCalendarDay, faSave, faEdit, faLayerGroup);


// Vue.use(VueAwesomeSwiper /* { default options with global component } */);


// import './registerServiceWorker';


const numeral = require('numeral');

Vue.filter('numFormat', value => numeral(value).format('0,0')); // displaying other groupings/separators is possible, look at the docs

Vue.config.productionTip = false;
// import additional js / css modules
Vue.use(require('vue-moment'));

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueAwesomeSwiper);
Vue.use(IdleVue, { store, idleTime: 900000 });
Vue.use(VTooltip);
Vue.use(VueTelInput, { validCharactersOnly: true });
Vue.use(VueMasonryPlugin);
Vue.use(vueDebounce);
Vue.use(Vuelidate);
Vue.use(PrettyCheckbox);
Vue.use(VueMeta);


// eslint-disable-next-line func-names, no-extend-native
String.prototype.base64ToBlob = function (mime) {
    const bstr = atob(this);
    const ab = bstr.s2ab();
    return new Blob([ab], { type: mime });
};

// eslint-disable-next-line func-names, no-extend-native
String.prototype.s2ab = function () {
    const buf = new ArrayBuffer(this.length);
    const view = new Uint8Array(buf);
    // eslint-disable-next-line no-bitwise
    for (let i = 0; i !== this.length; ++i) view[i] = this.charCodeAt(i) & 0xFF;
    return buf;
};

store.dispatch('analytics/init', router);

// axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
// axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
